<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart
        :force-fit="true"
        :height="height"
        :data="data"
        :color="'#1890FF'"
        :padding="[36, 5, 18, 5]"
      >
        <v-tooltip />
        <v-bar position="x*y" />
      </v-chart>
    </div>
  </div>
</template>

<script>
const tooltip = [
  'x*y',
  (x, y) => ({
    name: x,
    value: y
  })
];

const scale = [
  {
    dataKey: 'x',
    min: 0
  },
  {
    dataKey: 'y',
    title: '时间'
  }
];

export default {
  props: {
    data: {
      type: Array
    }
  },

  name: 'MiniBar',
  data() {
    return {
      tooltip,
      scale,
      height: 100
    };
  }
};
</script>

<style lang="scss" scoped>
.antv-chart-mini {
  position: relative;
  width: 100%;

  .chart-wrapper {
    position: absolute;
    bottom: -28px;
    width: 100%;

    /*    margin: 0 -5px;
    overflow: hidden;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/MiniBar.vue